import React from 'react'
import './calendary.css';
import { HiOutlineCalendar, HiChevronRight } from 'react-icons/hi';

const Calendary = () => {
    return (
        <div className='app-container'>
            <p className='app-subtitle'>Data</p>
            <div className='calendary-container'>
                <HiOutlineCalendar className="icon active left" />
                <p className='date-text'>Segunda-feira, 20 de abril de 2016</p>
                <HiChevronRight className="date-arrow right" />
            </div>
        </div>
    )
}

export default Calendary